import get from 'lodash/get';
import { useFormContext } from 'react-hook-form';
import { useDeprecatedFieldsContext } from '../contexts';
export var useDeprecationFilteredValues = function (name, options, valueGetter) {
    var _a;
    var _b = useDeprecatedFieldsContext(), overrideDataSource = _b.overrideDataSource, deprecatedValues = _b.deprecatedValues;
    var _c = (_a = useFormContext()) !== null && _a !== void 0 ? _a : {}, getValues = _c.getValues, setValue = _c.setValue;
    var getDeprecationFilteredValues = function (options, valueGetter) {
        // if field has no depreciated values, do nothing
        if (!deprecatedValues[name]) {
            return options;
        }
        else if (overrideDataSource && get(overrideDataSource, name)) {
            // if field has deprecated values but override has a value on the field, make sure to preserve the selection
            return options.filter(function (option) {
                return !deprecatedValues[name].includes(valueGetter(option)) ||
                    valueGetter(option) === get(overrideDataSource, name);
            });
        }
        else {
            // if field has deprecated values and no override, unset if currently set to one of the deprecated values
            if (deprecatedValues[name].includes(getValues(name))) {
                setValue(name, '');
            }
            // if field has deprecated values and no override, get rid of deprecated values
            return options.filter(function (option) { return !deprecatedValues[name].includes(valueGetter(option)); });
        }
    };
    return {
        getDeprecationFilteredValues: getDeprecationFilteredValues,
        values: getDeprecationFilteredValues(options, valueGetter),
    };
};
